module.exports = __webpack_public_path__ + "static/media/text_mayu.e1765f8e.png";